import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../../../assets/logos/golden-logo.svg";
import Button from '../../common/Button/Button';
import styles from "../ErrorPage/ErrorPage.module.scss";
import { HomeIcon } from '../../../assets/icons/svgicons';
import { Container } from 'react-bootstrap';

const PageNotFound = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className={styles.error_page}>
                <Container>
                    <div className={styles.error_in}>
                        <img src={logo} alt="logo" />
                        <h1>404</h1>
                        <h3>Oops! Page not found</h3>
                        <Button
                            onClick={() => navigate(-1)}
                        >
                            <HomeIcon /> Back to home
                        </Button>
                    </div>
                </Container>
            </div>
        </>
    )
}

export default PageNotFound
